/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const MapPinBigIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "48", height: "48", fill: "none", viewBox: "0 0 48 48", "data-icon": true }, svg),
        React.createElement("g", { clipPath: "url(#clip0_11235_69733)" },
            React.createElement("path", { fill: fillColor, fillRule: "evenodd", d: "M24 42a6 6 0 100-12 6 6 0 000 12z", clipRule: "evenodd", opacity: ".15" }),
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M24 46c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z", clipRule: "evenodd", opacity: ".1" }),
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M23.602 2c-3.36 0-6.721 1.434-9.241 3.892C12.05 8.145 11 11.012 11 13.879c0 0.82 0 1.434 0.21 2.254v0.204c1.68 8.808 11.342 19.049 11.762 19.253l0.42 0.41 0.63-0.41c0.63-0.41 11.972-12.698 11.972-21.915C36.204 7.53 30.534 2 23.602 2zM23.5 20C20 20 17 17.23 17 14s3-6 6.5-6 6.5 2.77 6.5 6-2.75 6-6.5 6z", clipRule: "evenodd" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_11235_69733" },
                React.createElement("rect", { width: "48", height: "48", fill: "currentColor" })))));
};
//# sourceMappingURL=MapPinBigIcon.js.map